import { render, staticRenderFns } from "./newProduct.vue?vue&type=template&id=174d1eee&scoped=true"
import script from "./newProduct.vue?vue&type=script&lang=js"
export * from "./newProduct.vue?vue&type=script&lang=js"
import style0 from "./newProduct.vue?vue&type=style&index=0&id=174d1eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174d1eee",
  null
  
)

export default component.exports